<div class="relative mt-8 flex flex-auto flex-col items-center gap-8 px-6">
  @if (session(); as sess) {
    <div class="w-full max-w-4xl flex flex-col gap-6">
      <!-- General Header Info Card -->
      <div class="surface-default flex flex-col gap-4 rounded-xl border border-neutral-a4 p-6 shadow-sm">
        <div class="flex items-center justify-between border-b border-neutral-a4 pb-4">
          <div class="flex items-center gap-3">
            <mat-icon class="text-primary size-6 flex items-center justify-center">fingerprint</mat-icon>
            <span class="text-lg font-bold text-primary">Session de Vérification</span>
          </div>
          @if (sess.stripeReportId) {
            <aura-simple-chip text="Rapport Stripe Associé" />
          }
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-y-4 gap-x-8 text-sm">
          <div class="flex flex-col gap-1 col-span-1 md:col-span-2">
            <span class="text-xs text-gray-500 font-medium">Utilisateur</span>
            @if (populatedUser(); as user) {
              <div class="flex items-center gap-2">
                <a
                  [routerLink]="['/users', $safeNavigationMigration($any(user)?._id)]"
                  class="font-semibold text-primary hover:underline"
                >
                  {{ $any(user)?.identity?.firstName }} {{ $any(user)?.identity?.lastName }}
                </a>
                <span class="text-xs text-gray-500">({{ $any(user)?.email }})</span>
              </div>
            } @else {
              <span class="font-mono text-gray-400">{{ sess.userId }}</span>
            }
          </div>

          <div class="flex flex-col gap-1">
            <span class="text-xs text-gray-500 font-medium">ID Session Stripe</span>
            <span class="font-mono text-gray-800 break-all select-all">{{ sess.stripeSessionId }}</span>
          </div>

          <div class="flex flex-col gap-1">
            <span class="text-xs text-gray-500 font-medium">ID Rapport Stripe</span>
            <span class="font-mono text-gray-850 break-all select-all">{{
              sess.stripeReportId || 'En attente'
            }}</span>
          </div>

          <div class="flex flex-col gap-1">
            <span class="text-xs text-gray-500 font-medium">Créé le</span>
            <span class="text-gray-800">{{ sess.createdAt | luxonDate: 'dd/LL/yyyy, HH:mm' }}</span>
          </div>
        </div>
      </div>

      <!-- Identity Verification details if present -->
      @if (sess.identity) {
        <div class="surface-default flex flex-col gap-4 rounded-xl border border-neutral-a4 p-6 shadow-sm">
          <div class="flex items-center gap-3 border-b border-neutral-a4 pb-4">
            <mat-icon class="text-primary size-6 flex items-center justify-center">assignment_ind</mat-icon>
            <span class="text-lg font-bold text-primary">Informations d'identité fournies</span>
          </div>
          <aura-code-block [code]="sess.identity" />
        </div>
      }

      <!-- Metadata -->
      @if (sess.metadata) {
        <div class="surface-default flex flex-col gap-4 rounded-xl border border-neutral-a4 p-6 shadow-sm">
          <div class="flex items-center gap-3 border-b border-neutral-a4 pb-4">
            <mat-icon class="text-primary size-6 flex items-center justify-center">label</mat-icon>
            <span class="text-lg font-bold text-primary">Métadonnées de la session</span>
          </div>
          <aura-code-block [code]="sess.metadata" />
        </div>
      }
    </div>
  }
</div>
